export default function (router) {
  router.afterEach(() => {
    $(document).find('#main').removeClass('modal-open')
  })
}
